import dayjs from 'dayjs'

// 金額以「最小貨幣單位整數」儲存（例如日圓 1200 -> 120000，因為 JPY 沒有分，這裡統一以 x100 存放避免浮點誤差）
export function toMinor (amount) {
  return Math.round(Number(amount) * 100)
}

export function fromMinor (amountMinor) {
  return amountMinor / 100
}

export function formatMoney (amountMinor, currency) {
  const value = fromMinor(amountMinor)
  const formatted = value.toLocaleString('zh-Hant', {
    minimumFractionDigits: value % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2
  })
  return `${currency} ${formatted}`
}

export function formatDate (value, pattern = 'YYYY-MM-DD') {
  if (!value) return ''
  return dayjs(value).format(pattern)
}

export function formatDateTime (value) {
  if (!value) return ''
  return dayjs(value).format('MM/DD HH:mm')
}

export function formatTime (value) {
  if (!value) return ''
  return dayjs(value).format('HH:mm')
}

export function dayLabel (value) {
  if (!value) return ''
  return dayjs(value).format('YYYY年MM月DD日')
}
